module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Honey3_Side.5fb91798.png";